import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { useCreateWorkspace, useRestoreWorkspace, useWorkspaces } from "../api/hooks";
import { setDeletedWorkspace, useDeletedWorkspace } from "../lib/deletedWorkspace";
import { Button } from "../ui/Button";
import { Input } from "../ui/Input";
import { useT } from "../i18n";
import { roleKey } from "../i18n/roles";

export function WorkspaceListPage() {
  const t = useT();
  const ws = useWorkspaces();
  const create = useCreateWorkspace();
  const [name, setName] = useState("");
  const deleted = useDeletedWorkspace();
  const restore = useRestoreWorkspace();
  return (
    <div className="mx-auto max-w-2xl px-9 pb-16 pt-8">
      <header className="mb-6">
        <h1 className="text-[26px] font-semibold">{t("ws.list.title")}</h1>
        <p className="text-sm text-neutral-500">{t("ws.list.lead")}</p>
      </header>
      {deleted && (
        <div className="kss-surface mb-4 flex items-center gap-3 px-4 py-3 text-sm" role="status" data-testid="workspace-deleted-notice">
          <span className="grow">{t("ws.list.deleted", { name: deleted.name })}</span>
          <Button
            variant="ghost"
            disabled={restore.isPending}
            onClick={() => restore.mutate(deleted.id, { onSuccess: () => setDeletedWorkspace(null) })}
            data-testid="workspace-deleted-undo"
          >
            {t("ws.list.deleted.undo")}
          </Button>
        </div>
      )}
      <ul className="kss-surface mb-6 divide-y divide-neutral-200 p-0 dark:divide-neutral-800">
        {ws.data?.map((w) => (
          <li key={w.id} className="flex items-center gap-2 px-4 py-3.5">
            <Link to="/w/$workspaceId" params={{ workspaceId: w.id }} className="font-semibold text-neutral-900 hover:text-accent dark:text-neutral-100">
              {w.name}
            </Link>
            <span className="kss-pill border-neutral-200 text-neutral-500 dark:border-neutral-700">{t(roleKey(w.my_role))}</span>
          </li>
        ))}
        {ws.data?.length === 0 && <li className="px-4 py-3.5 text-neutral-500">{t("ws.list.empty")}</li>}
      </ul>
      <form
        className="flex gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          if (name.trim()) create.mutate(name.trim(), { onSuccess: () => setName("") });
        }}
      >
        <Input placeholder={t("ws.list.newName")} value={name} onChange={(e) => setName(e.target.value)} />
        <Button type="submit" disabled={create.isPending}>
          {t("ws.list.create")}
        </Button>
      </form>
    </div>
  );
}
